import { styled } from "@mui/material/styles";

export const Wrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 12,

  width: "100%",
  "@media screen and (max-width: 435px)": {
    marginBottom: 24,
  },
}));

export const Image = styled("img")(() => ({
  height: 350,
  "@media screen and (max-width: 435px)": {
    height: 250,
  },
}));

export const Title = styled("span")(() => ({
  font: "600 16px/24px Manrope",
  color: "#465869",
}));
